import styles from './JoinClassRequests.css'
import { useState, useEffect } from 'react'
import axiosConfig from '../../../../utils/axiosConfig';
import { Button, Divider, Box, List } from '@material-ui/core'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'

import JoinClassRequestItem from './JoinClassRequestItem';

const JoinClassRequests = ({classroomRequests, requestCancelled}) => {
    const [showDialog, setShowDialog] = useState(false)
    const [requests, setRequests] = useState([])

    const handleClose = () => {
        setShowDialog(false)
    }

    useEffect(() => {
        setRequests(classroomRequests)

        if (requests.length === 0) {
            handleClose()
        }
    }, [classroomRequests])

    return (
        <>
            { requests.length > 0 && <Button
                variant="outlined"
                color="primary"
                size="medium"
                onClick={() => setShowDialog(true)}
            >
                Join Request ({requests.length})
            </Button> }

            <Dialog id="dialog-main-container" open={showDialog}>
                <DialogTitle>Classroom Requests</DialogTitle>
                <Divider />
                <DialogContent>
                    <Box>
                        <List dense>
                            {requests.map((request) => (
                                <JoinClassRequestItem
                                    request={request}
                                    closeModal={handleClose}
                                    itemCancelled={requestCancelled}
                                />
                            ))}
                        </List>
                    </Box>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default JoinClassRequests